<template>
    <div class="base-card__content base-card__zoom base-card__shadow show-all-content" :class="`${classModifier}_show-all`">
        <common-icon :icon-name="'IconShowAll'" />
        <div class="show-all-content__text">{{ name }}</div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType, computed } from "vue";
    import { type ShowAllCardData } from "../../models";

    const props = defineProps({
        cardData: {
            type: Object as PropType<ShowAllCardData>,
            required: true
        },
    });

    const name = computed((): string => props.cardData.getName());
    const classModifier = computed((): string => props.cardData.getClass());
</script>

<style lang="scss">
    @import url("styles.scss");
</style>